import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Dropdown, Menu, Typography, Spin, notification } from "antd";
import { DownOutlined, EyeOutlined } from "@ant-design/icons";
import axios from "axios";
import PartnershipForm from "./PartnershipForm"; // Import the PartnershipForm component
import { getPartnershipResponses } from "../../api";

const { Title } = Typography;

const PartnershipResponses = () => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedResponse, setSelectedResponse] = useState(null);

  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    fetchResponses();
  }, []);

  const fetchResponses = async () => {
    try {
      const res = await getPartnershipResponses();
      setResponses(res.data);
    } catch (error) {
      notification.error("Failed to fetch partnership responses.");
      console.error("Error fetching responses:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewResponse = (record) => {
    setSelectedResponse(record)
    setModalVisible(true);
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      render: (_, record) => record.fullName?.split(" ")[0] || "N/A",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      render: (_, record) => record.fullName?.split(" ")[1] || "N/A",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="view" icon={<EyeOutlined />} onClick={() => handleViewResponse(record)}>
                View Response
              </Menu.Item>
            </Menu>
          }
        >
          <Button>
            Actions <DownOutlined />
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <div style={{ margin: "auto", padding: 20 }}>
      <Title level={2}>Partnership Form Responses</Title>
      {loading ? (
        <div className="fixed-loader ">
          <Spin size="large" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={responses}
          rowKey="_id"
          pagination={{ pageSize: 10 }}
        />
      )}

      {/* Modal for Viewing Response */}
      <Modal
        title="View Partnership Response"
        visible={modalVisible}
        onCancel={() => { setModalVisible(false); setSelectedResponse('') }}
        footer={[
          <Button key="close" onClick={() => { setModalVisible(false); setSelectedResponse('') }}>
            Close
          </Button>,
        ]}
        width={850}
      >
        {selectedResponse && <PartnershipForm key={Math.random()} selectedResponse={selectedResponse} />}
      </Modal>
    </div>
  );
};

export default PartnershipResponses;
